export enum Gender {
  Women = 'Women',
  Men = 'Men',
  Fluid = 'Fluid',
}

export enum ProductType {
  Tops = 'Tops',
  Dresses = 'Dresses',
  OnePieces = 'One-Pieces',
  Pants = 'Pants',
  Skirts = 'Skirts',
  IntimatesSwim = 'Intimates + Swim',
  Activewear = 'Activewear',
  Outerwear = 'Outerwear',
  Bags = 'Bags',
  Accessories = 'Accessories',
  Shoes = 'Shoes',
  Jewelry = 'Jewelry',
}

export enum TopsSubtype {
  Tees = 'Tees',
  ShirtsBlouses = 'Shirts + Blouses',
  Tanks = 'Tanks',
  Strapless = 'Strapless',
  CropTops = 'Crop Tops',
  SweatersHoodies = 'Sweaters + Hoodies',
  KnittedTop = 'Knitted Top',
  Corsets = 'Corsets',
}

export enum DressesSubtype {
  MiniDress = 'Mini Dress',
  MidiDress = 'Midi Dress',
  MaxiDress = 'Maxi Dress',
  Formal = 'Formal',
  Vacation = 'Vacation',
  Everyday = 'Every-day',
  SleevelessDress = 'Sleeveless Dress',
  ShortSleeveDress = 'Short-Sleeve Dress',
  LongSleeveDress = 'Long-Sleeve Dress',
}

export enum OnePiecesSubtype {
  Bodysuit = 'Bodysuit',
  Jumpsuit = 'Jumpsuit',
  Romper = 'Romper',
  Overalls = 'Overalls',
}

export enum PantsSubtype {
  FittedPants = 'Fitted Pants',
  Trousers = 'Trousers',
  CargoPants = 'Cargo Pants',
  Overalls = 'Overalls',
  Jeans = 'Jeans',
  Leggings = 'Leggings',
  SweatpantsJoggers = 'Sweatpants + Joggers',
  Shorts = 'Shorts',
}

export enum SkirtsSubtype {
  MiniSkirt = 'Mini Skirt',
  MidiSkirt = 'Midi Skirt',
  MaxiSkirt = 'Maxi Skirt',
  PleatedSkirt = 'Pleated Skirt',
  WrapSkirt = 'Wrap Skirt',
}

export enum IntimatesSwimSubtype {
  Bra = 'Bra',
  Undies = 'Undies',
  Lingerie = 'Lingerie',
  Bikini = 'Bikini',
  Monokini = 'Monokini',
  Trunks = 'Trunks',
}

export enum ActivewearSubtype {
  ActiveTop = 'Active Top',
  Sweatshirt = 'Sweatshirt',
  SportsBra = 'Sports Bra',
  Leggings = 'Leggings',
  Shorts = 'Shorts',
  OnsiesSinglets = 'Onsies + Singlets',
  SweatpantsJoggers = 'Sweatpants + Joggers',
}

export enum OuterwearSubtype {
  Coat = 'Coat',
  Jacket = 'Jacket',
  OuterwearVest = 'Outerwear Vest',
  Blazer = 'Blazer',
  Shawl = 'Shawl',
  Cardigan = 'Cardigan',
  FauxFurCoat = 'Faux-Fur Coat',
  PufferCoat = 'Puffer Coat',
}

export enum BagsSubtype {
  Clutch = 'Clutch',
  Purse = 'Purse',
  Handbag = 'Handbag',
  Backpack = 'Backpack',
  BeltHarnessBag = 'Belt / Harness Bag',
  ToteBag = 'Tote Bag',
  Wallet = 'Wallet',
  SculpturalBag = 'Sculptural Bag',
}

export enum AccessoriesSubtype {
  HatsHeadwear = 'Hats + Headwear',
  HairClipsHeadband = 'Hair Clips + Headband',
  Balaclava = 'Balaclava',
  SunglassesEyewear = 'Sunglasses + Eyewear',
  Mask = 'Mask',
  ScarvesNeckwear = 'Scarves + Neckwear',
  GlovesArmwear = 'Gloves + Armwear',
  Belt = 'Belt',
  CorsetBelt = 'Corset Belt',
  Harness = 'Harness',
  TightsStockings = 'Tights + Stockings',
  Socks = 'Socks',
  Nails = 'Nails',
  Keychain = 'Keychain',
  Watch = 'Watch',
}

export enum ShoesSubtype {
  Boots = 'Boots',
  Flats = 'Flats',
  Workwear = 'Workwear',
  Heels = 'Heels',
  Platforms = 'Platforms',
  SandalsSlides = 'Sandals + Slides',
  Slippers = 'Slippers',
  Sneakers = 'Sneakers',
}

export enum JewelrySubtype {
  Necklaces = 'Necklaces',
  EarringsCuffs = 'Earrings + Cuffs',
  Rings = 'Rings',
  Bracelets = 'Bracelets',
  BodyPiercings = 'Body-Piercings',
  FaceToothGems = 'Face + Tooth Gems',
  BodyChains = 'Body Chains',
  HairClipsHeadbandsJewelry = 'Hair Clips + Headbands - Jewelry',
}

export enum SuitSetSubtype {
  Suit = 'Suit',
  Set = 'Set',
}

export enum Color {
  Black = 'Black',
  White = 'White',
  Silver = 'Silver',
  Gold = 'Gold',
  Metallic = 'Metallic',
  Grey = 'Grey',
  Brown = 'Brown',
  Red = 'Red',
  Pink = 'Pink',
  Orange = 'Orange',
  Yellow = 'Yellow',
  Green = 'Green',
  Blue = 'Blue',
  Purple = 'Purple',
}
